import { render, staticRenderFns } from "./ImageAttrWithDetail.vue?vue&type=template&id=517c39d6&scoped=true&"
import script from "./ImageAttrWithDetail.vue?vue&type=script&lang=js&"
export * from "./ImageAttrWithDetail.vue?vue&type=script&lang=js&"
import style0 from "./ImageAttrWithDetail.vue?vue&type=style&index=0&id=517c39d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c39d6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default,TheBlockHeader: require('/web/components/TheBlockHeader.vue').default})
